import React, { useState, useEffect } from 'react';
import { automationsAPI, handleAPIError } from '../api';

const Automations = () => {
  const [automations, setAutomations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('list');

  useEffect(() => {
    loadAutomations();
  }, []);

  const loadAutomations = async () => {
    try {
      setLoading(true);
      const response = await automationsAPI.getAll();
      if (response.success) {
        setAutomations(response.data);
        setError(null);
      } else {
        setError('Error al cargar automatizaciones');
      }
    } catch (err) {
      const errorInfo = handleAPIError(err);
      setError(errorInfo.message);
    } finally {
      setLoading(false);
    }
  };

  const renderTabContent = () => {
    if (loading) {
      return <div className="loading">Cargando automatizaciones...</div>;
    }

    if (error) {
      return (
        <div className="message message-error">
          {error}
        </div>
      );
    }

    switch (activeTab) {
      case 'list':
        return (
          <div>
            <h3 className="title-secondary">
              Automatizaciones Activas
            </h3>
            {automations.length === 0 ? (
              <p className="description">
                No hay automatizaciones configuradas.
              </p>
            ) : (
              automations.map((automation, index) => (
                <div key={index} className="card">
                  <h4 className="title-tertiary">
                    {automation.name}
                  </h4>
                  <p className="description">
                    {automation.description}
                  </p>
                  <p className="description" style={{ fontSize: '14px' }}>
                    Estado: <strong>{automation.status}</strong> | 
                    Última ejecución: {automation.lastRun || 'Nunca'}
                  </p>
                  <button className="btn-primary">
                    Ejecutar
                  </button>
                  <button className="btn-secondary">
                    Configurar
                  </button>
                </div>
              ))
            )}
          </div>
        );
      case 'create':
        return (
          <div className="card">
            <h3 className="title-secondary">
              Crear Nueva Automatización
            </h3>
            <p className="description">
              Funcionalidad en desarrollo...
            </p>
          </div>
        );
      case 'logs':
        return (
          <div className="card">
            <h3 className="title-secondary">
              Logs de Automatizaciones
            </h3>
            <p className="description">
              Aquí se mostrarán los logs de ejecución...
            </p>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="main-container">
      <div className="content-header">
        <h1 className="title-primary">Automatizaciones</h1>
        <p className="subtitle">
          Gestiona y configura procesos automatizados de análisis de datos
        </p>
      </div>

      <div className="tab-container">
        <button
          className={`tab ${activeTab === 'list' ? 'tab-active' : 'tab-inactive'}`}
          onClick={() => setActiveTab('list')}
        >
          Lista
        </button>
        <button
          className={`tab ${activeTab === 'create' ? 'tab-active' : 'tab-inactive'}`}
          onClick={() => setActiveTab('create')}
        >
          Crear
        </button>
        <button
          className={`tab ${activeTab === 'logs' ? 'tab-active' : 'tab-inactive'}`}
          onClick={() => setActiveTab('logs')}
        >
          Logs
        </button>
      </div>

      {renderTabContent()}
    </div>
  );
};

export default Automations;